import { api } from "@/utils/client";
import { keyBy, map, sortBy } from 'lodash-es';
import Vue from "vue";

export default {
    namespaced: true,
    state: {
        ids: [],
        list: {},
        meta: {},
        selected: undefined,
    },
    getters: {
        orderedList(state) {
            return state.ids
                .map(id => state.list[id]);
        },
        selected(state) {
            return state.list[state.selected];
        }
    },
    mutations: {
        setList(state, list) {
            state.list = keyBy(list, 'id');
            state.ids = map(list, 'id');

        },
        setIds(state, ids) {
            state.ids = ids;
        },
        addItem(state, {id, ...item}) {
            Vue.set(state.list, id, {id, ...item})
        },
        updateItem(state, {id, ...item}) {
            Vue.set(state.list, id, {id, ...item})
        },
        removeItem(state, id) {
            state.ids = state.ids.filter((_id) => _id !== id);
            Vue.delete(state.list, id)
        },
        setMeta(state, meta) {
            state.meta = meta;
        },
        setSelected(state, selected) {
            state.selected = selected;
        },
        reorderItems(state) {
            state.ids = map(sortBy(state.list, 'order'), 'id');
        }
    },
    actions: {
        async getList({commit, state, rootState}, params) {
            const {
                data: {
                    data,
                    meta
                }
            } = await api.get(`templates/${rootState.surveyTemplates.selected}/pages/${rootState.surveyTemplatePages.selected}/questions`, {
                params: {
                    ...params,
                    deleted: state.showingDeleted ? 1 : 0
                }
            })
            commit('setList', data);
            commit('setMeta', meta);
            return data;
        },
        async getById({commit, rootState}, id) {
            const {data: {data}} = await api.get(`templates/${rootState.surveyTemplates.selected}/pages/${rootState.surveyTemplatePages.selected}/questions/${id}`,)
            commit('addItem', data);
            commit('reorderItems');
            return data;
        },
        async create({commit, rootState}, payload) {
            const {data: {data}} = await api.post(`templates/${rootState.surveyTemplates.selected}/pages/${rootState.surveyTemplatePages.selected}/questions`, payload)
            commit('addItem', data);
            commit('reorderItems');
            return data;
        },
        async update({commit, rootState}, {id, ...payload}) {
            const {data: {data}} = await api.put(`templates/${rootState.surveyTemplates.selected}/pages/${rootState.surveyTemplatePages.selected}/questions/${id}`, payload)
            commit('updateItem', data);
            commit('reorderItems');
            return data;
        },
        async delete({commit, rootState}, id) {
            const {data: {data}} = await api.delete(`templates/${rootState.surveyTemplates.selected}/pages/${rootState.surveyTemplatePages.selected}/questions/${id}`)
            commit('updateItem', data);
            commit('reorderItems');
            return data;
        },
        async restore({commit, rootState}, id) {
            const {data: {data}} = await api.put(`templates/${rootState.surveyTemplates.selected}/pages/${rootState.surveyTemplatePages.selected}/questions/${id}/restore`)
            commit('updateItem', data);
            commit('reorderItems');
            return data;
        },
        async forceDelete({commit, rootState}, id) {
            const {data: {data}} = await api.delete(`templates/${rootState.surveyTemplates.selected}/pages/${rootState.surveyTemplatePages.selected}/questions/${id}`, {data: {permanent: true}})
            commit('removeItem', id);
            return data;
        },
        async reorder({commit, rootState, state, getters}, ids) {
            commit('setList', ids.map((id, index) => ({
                ...state.list[id],
                order: index + 1
            })))

            const payload = getters.orderedList.map(({id, order}) => ({id, order}));
            const {data: {data}} = await api.patch(`templates/${rootState.surveyTemplates.selected}/pages/${rootState.surveyTemplatePages.selected}/questions`, payload)
            commit('reorderItems', data);

        }
    }

}
